var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { useWeb3Wallet } from "shared/lib/hooks/useWeb3Wallet";
import { parseUnits } from "@ethersproject/units";
import { useLocation } from "react-router-dom";
import colors from "shared/lib/designSystem/colors";
import { AVAX_BRIDGE_URI, isAvaxNetwork, VaultAddressMap, VaultAllowedDepositAssets, VaultMaxDeposit, isDisabledVault, isNoApproveToken, } from "shared/lib/constants/constants";
import { ExternalIcon } from "shared/lib/assets/icons/icons";
import { ACTIONS } from "../Modal/types";
import useVaultActionForm from "../../../../hooks/useVaultActionForm";
import { BaseLink, SecondaryText, Title } from "shared/lib/designSystem";
import useTokenAllowance from "shared/lib/hooks/useTokenAllowance";
import { useV2VaultData, useAssetBalance, } from "shared/lib/hooks/web3DataContext";
import { isVaultFull } from "shared/lib/utils/vault";
import { getAssetDisplay, getAssetColor } from "shared/lib/utils/asset";
import { formatBigNumber } from "shared/lib/utils/math";
import VaultApprovalForm from "../common/VaultApprovalForm";
import ButtonArrow from "shared/lib/components/Common/ButtonArrow";
import theme from "shared/lib/designSystem/theme";
import SwapBTCDropdown from "../common/SwapBTCDropdown";
import VaultBasicAmountForm from "../common/VaultBasicAmountForm";
import VaultV2WithdrawForm from "./VaultV2WithdrawForm";
import useVaultPriceHistory from "shared/lib/hooks/useVaultPerformanceUpdate";
import { BigNumber } from "ethers";
import { useTranslation } from "react-i18next";
var BridgeText = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 14px;\n"], ["\n  font-size: 14px;\n"])));
var BridgeButton = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10px 16px;\n  background: ", "14;\n  border: 1px solid ", ";\n  border-radius: 100px;\n  color: white;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10px 16px;\n  background: ", "14;\n  border: 1px solid ", ";\n  border-radius: 100px;\n  color: white;\n"])), function (props) { return props.color; }, function (props) { return props.color; });
var FormTabContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-evenly;\n  position: relative;\n\n  &:before {\n    display: block;\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    content: \" \";\n    z-index: -1;\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-evenly;\n  position: relative;\n\n  &:before {\n    display: block;\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    content: \" \";\n    z-index: -1;\n  }\n"])));
var FormTab = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  padding: 24px 0;\n  background-color: ", ";\n  cursor: pointer;\n\n  &:after {\n    background-color: white;\n  }\n\n  &:first-child {\n    border-top-left-radius: 8px;\n  }\n\n  &:last-child {\n    border-top-right-radius: 8px;\n  }\n"], ["\n  width: 100%;\n  padding: 24px 0;\n  background-color: ", ";\n  cursor: pointer;\n\n  &:after {\n    background-color: white;\n  }\n\n  &:first-child {\n    border-top-left-radius: 8px;\n  }\n\n  &:last-child {\n    border-top-right-radius: 8px;\n  }\n"])), function (props) {
    return props.active ? "none" : "rgba(255,255,255,0.04)";
});
var FormTabTitle = styled(Title)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  line-height: 24px;\n  text-transform: uppercase;\n  color: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  line-height: 24px;\n  text-transform: uppercase;\n  color: ", ";\n"])), function (props) { return (props.active ? "#f3f3f3" : "rgba(255, 255, 255, 0.64)"); });
var FormInfoText = styled(Title)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 24px;\n  text-align: center;\n  color: ", ";\n"], ["\n  font-size: 14px;\n  line-height: 24px;\n  text-align: center;\n  color: ", ";\n"])), function (props) { return (props.color ? props.color : colors.text); });
var SwapTriggerContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var SwapTriggerButton = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  margin-top: 24px;\n  border: ", " ", " ", ";\n  border-radius: 100px;\n  padding: 8px 16px;\n  width: 300px;\n  display: flex;\n  align-items: center;\n"], ["\n  margin-top: 24px;\n  border: ", " ", " ", ";\n  border-radius: 100px;\n  padding: 8px 16px;\n  width: 300px;\n  display: flex;\n  align-items: center;\n"])), theme.border.width, theme.border.style, colors.border);
var SwapTriggerButtonText = styled(SecondaryText)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"])));
var VaultV2DepositWithdrawForm = function (_a) {
    var _b;
    var vaultOption = _a.vaultOption, onFormSubmit = _a.onFormSubmit;
    /**
     * Primary hooks
     */
    var _c = useVaultActionForm(vaultOption), handleActionTypeChange = _c.handleActionTypeChange, vaultActionForm = _c.vaultActionForm, handleMaxClick = _c.handleMaxClick;
    var _d = useState(false), showTokenApprovalForm = _d[0], setShowTokenApprovalForm = _d[1];
    var _e = useV2VaultData(vaultOption), _f = _e.data, asset = _f.asset, cap = _f.cap, decimals = _f.decimals, depositBalanceInAsset = _f.depositBalanceInAsset, lockedBalanceInAsset = _f.lockedBalanceInAsset, round = _f.round, totalBalance = _f.totalBalance, withdrawals = _f.withdrawals, loading = _e.loading;
    var userAssetBalance = useAssetBalance(vaultActionForm.depositAsset || asset).balance;
    var vaultBalanceInAsset = depositBalanceInAsset.add(lockedBalanceInAsset);
    var priceHistory = useVaultPriceHistory(vaultOption, "v2").priceHistory;
    var _g = useWeb3Wallet(), active = _g.active, chainId = _g.chainId;
    var t = useTranslation().t;
    var vaultMaxDepositAmount = VaultMaxDeposit[vaultOption];
    var isInputNonZero = parseFloat(vaultActionForm.inputAmount) > 0;
    var avalancheColor = getAssetColor(vaultOption === "rsAVAX-THETA" ? "sAVAX" : "WAVAX");
    var canCompleteWithdraw = useMemo(function () {
        return (vaultActionForm.withdrawOption !== "instant" &&
            !withdrawals.shares.isZero() &&
            withdrawals.round !== round);
    }, [round, vaultActionForm.withdrawOption, withdrawals]);
    var withdrawalAmount = useMemo(function () {
        var _a;
        return withdrawals.shares
            .mul(((_a = priceHistory.find(function (history) {
            if (vaultOption === "rSOL-THETA") {
                return history.round === withdrawals.round - 1;
            }
            return history.round === withdrawals.round;
        })) === null || _a === void 0 ? void 0 : _a.pricePerShare) || BigNumber.from(0))
            .div(parseUnits("1", decimals));
    }, [
        decimals,
        priceHistory,
        withdrawals.round,
        withdrawals.shares,
        vaultOption,
    ]);
    /**
     * Side hooks
     */
    var tokenAllowance = useTokenAllowance(isNoApproveToken(vaultActionForm.depositAsset || asset)
        ? undefined
        : (((_b = vaultActionForm.depositAsset) === null || _b === void 0 ? void 0 : _b.toLowerCase()) ||
            VaultAllowedDepositAssets[vaultOption][0].toLowerCase()), VaultAddressMap[vaultOption].v2);
    /**
     * Default to initial state and process initial state
     */
    var _h = useState(false), processedInitialState = _h[0], setProcessedInitialState = _h[1];
    var location = useLocation();
    useEffect(function () {
        if (processedInitialState) {
            return;
        }
        var searchParams = new URLSearchParams(location.search);
        try {
            switch (searchParams.get("initialAction")) {
                case "completeWithdraw":
                    if (canCompleteWithdraw) {
                        handleActionTypeChange(ACTIONS.withdraw, "v2", {
                            withdrawOption: "complete",
                        });
                        handleMaxClick();
                        onFormSubmit();
                        setProcessedInitialState(true);
                    }
                    break;
                default:
                    handleActionTypeChange(ACTIONS.deposit, "v2");
                    setProcessedInitialState(true);
            }
        }
        catch (_a) {
            handleActionTypeChange(ACTIONS.deposit, "v2");
            setProcessedInitialState(true);
        }
    }, [
        canCompleteWithdraw,
        handleActionTypeChange,
        handleMaxClick,
        location.search,
        onFormSubmit,
        processedInitialState,
    ]);
    /**
     * Check if approval needed
     */
    var showTokenApproval = useMemo(function () {
        var amountBigNumber = parseUnits(vaultActionForm.inputAmount || "0", decimals);
        if (vaultActionForm.actionType === ACTIONS.deposit) {
            return (!isNoApproveToken(vaultActionForm.depositAsset ||
                VaultAllowedDepositAssets[vaultOption][0]) &&
                tokenAllowance &&
                tokenAllowance.lt(amountBigNumber));
        }
        return false;
    }, [
        decimals,
        tokenAllowance,
        vaultActionForm.actionType,
        vaultActionForm.depositAsset,
        vaultActionForm.inputAmount,
        vaultOption,
    ]);
    var _j = useState(false), swapContainerOpen = _j[0], setSwapContainerOpen = _j[1];
    var error = useMemo(function () {
        switch (vaultActionForm.actionType) {
            case ACTIONS.deposit:
                /** Vault full */
                if (isVaultFull(totalBalance, cap, decimals)) {
                    return "vaultFull";
                }
                /** Max Deposited */
                if (vaultMaxDepositAmount.lt(vaultBalanceInAsset)) {
                    return "maxDeposited";
                }
                break;
        }
        try {
            /** Check block with input requirement */
            if (isInputNonZero && !loading && active) {
                var amountBigNumber = parseUnits(vaultActionForm.inputAmount, decimals);
                switch (vaultActionForm.actionType) {
                    case ACTIONS.deposit:
                        if (amountBigNumber.gt(userAssetBalance)) {
                            return "insufficientBalance";
                        }
                        if (amountBigNumber.gt(vaultMaxDepositAmount.sub(vaultBalanceInAsset))) {
                            return "maxExceeded";
                        }
                        if (amountBigNumber.gt(cap.sub(totalBalance))) {
                            return "capacityOverflow";
                        }
                        break;
                    case ACTIONS.withdraw:
                        switch (vaultActionForm.withdrawOption) {
                            case "instant":
                                if (amountBigNumber.gt(depositBalanceInAsset)) {
                                    return "withdrawLimitExceeded";
                                }
                                break;
                            case "standard":
                                if (amountBigNumber.gt(lockedBalanceInAsset)) {
                                    return "withdrawLimitExceeded";
                                }
                                if (canCompleteWithdraw) {
                                    return "existingWithdraw";
                                }
                                break;
                            case "complete":
                                if (amountBigNumber.gt(withdrawalAmount)) {
                                    return "withdrawLimitExceeded";
                                }
                                break;
                        }
                }
            }
        }
        catch (err) {
            // Assume no error because empty input unable to parse
        }
        return undefined;
    }, [
        active,
        canCompleteWithdraw,
        cap,
        decimals,
        depositBalanceInAsset,
        isInputNonZero,
        loading,
        lockedBalanceInAsset,
        totalBalance,
        userAssetBalance,
        vaultActionForm.actionType,
        vaultActionForm.inputAmount,
        vaultActionForm.withdrawOption,
        vaultBalanceInAsset,
        vaultMaxDepositAmount,
        withdrawalAmount,
    ]);
    var formContent = useMemo(function () {
        /**
         * Approval before deposit
         */
        if (showTokenApprovalForm && !isDisabledVault(vaultOption)) {
            return (_jsx(VaultApprovalForm, { vaultOption: vaultOption, version: "v2", showDepositAssetSwap: VaultAllowedDepositAssets[vaultOption].length > 1, setShowTokenApprovalForm: setShowTokenApprovalForm }, void 0));
        }
        switch (vaultActionForm.actionType) {
            case ACTIONS.deposit:
                return (_jsx(VaultBasicAmountForm, { vaultOption: vaultOption, error: error, formExtra: {
                        label: "Wallet Balance",
                        amount: userAssetBalance,
                        unitDisplay: getAssetDisplay(vaultActionForm.depositAsset || asset),
                        error: error === "insufficientBalance",
                    }, showSwapDepositAsset: VaultAllowedDepositAssets[vaultOption].length > 1, onFormSubmit: function () {
                        if (showTokenApproval) {
                            setShowTokenApprovalForm(true);
                        }
                        else {
                            onFormSubmit();
                        }
                    }, actionButtonText: "Preview Deposit" }, void 0));
            case ACTIONS.withdraw:
                return (_jsx(VaultV2WithdrawForm, { vaultOption: vaultOption, error: error, onFormSubmit: onFormSubmit, depositBalanceInAsset: depositBalanceInAsset, lockedBalanceInAsset: lockedBalanceInAsset, initiatedWithdrawAmount: withdrawalAmount, canCompleteWithdraw: canCompleteWithdraw }, void 0));
        }
    }, [
        asset,
        canCompleteWithdraw,
        depositBalanceInAsset,
        error,
        lockedBalanceInAsset,
        onFormSubmit,
        showTokenApproval,
        showTokenApprovalForm,
        userAssetBalance,
        vaultActionForm.actionType,
        vaultActionForm.depositAsset,
        vaultOption,
        withdrawalAmount,
    ]);
    var formInfoText = useMemo(function () {
        switch (error) {
            case "vaultFull":
                return (_jsx(FormInfoText, __assign({ color: colors.red }, { children: t("shared:VaultV2DepositWithdrawForm:currentlyFull") }), void 0));
            case "maxDeposited":
                return (_jsx(FormInfoText, __assign({ color: colors.red }, { children: t("shared:VaultV2DepositWithdrawForm:maxDeposit:explanation", {
                        maxDeposit: formatBigNumber(vaultMaxDepositAmount, decimals),
                        asset: getAssetDisplay(asset),
                    }) }), void 0));
        }
    }, [asset, decimals, error, vaultMaxDepositAmount, t]);
    var bridgeAvaxCTA = useMemo(function () {
        if (vaultActionForm.actionType === ACTIONS.deposit &&
            vaultActionForm.depositAsset &&
            chainId &&
            isAvaxNetwork(chainId)) {
            return (_jsx(BaseLink, __assign({ className: "mt-4", to: AVAX_BRIDGE_URI, target: "_blank", rel: "noreferrer noopener" }, { children: _jsxs(BridgeButton, __assign({ color: avalancheColor }, { children: [_jsx(BridgeText, __assign({ className: "mr-2" }, { children: t("shared:VaultV2DepositWithdrawForm:bridgeAvalanche") }), void 0), _jsx(ExternalIcon, { color: "white" }, void 0)] }), void 0) }), void 0));
        }
    }, [
        chainId,
        vaultActionForm.actionType,
        vaultActionForm.depositAsset,
        avalancheColor,
        t,
    ]);
    var swapContainerTrigger = useMemo(function () {
        switch (asset) {
            case "WBTC":
                return (_jsx(SwapTriggerContainer, { children: _jsxs(SwapTriggerButton, __assign({ role: "button", onClick: function () { return setSwapContainerOpen(function (open) { return !open; }); } }, { children: [_jsx(SwapTriggerButtonText, { children: t("shared:VaultV2DepositWithdrawForm:swapBTC") }, void 0), _jsx(ButtonArrow, { isOpen: swapContainerOpen, color: colors.primaryText }, void 0)] }), void 0) }, void 0));
            default:
                return _jsx(_Fragment, {}, void 0);
        }
    }, [asset, swapContainerOpen, t]);
    var swapContainer = useMemo(function () {
        switch (asset) {
            case "WBTC":
                return _jsx(SwapBTCDropdown, { open: swapContainerOpen }, void 0);
            default:
                return _jsx(_Fragment, {}, void 0);
        }
    }, [asset, swapContainerOpen]);
    return (_jsxs(_Fragment, { children: [_jsxs(FormTabContainer, { children: [_jsx(FormTab, __assign({ active: vaultActionForm.actionType === ACTIONS.deposit, onClick: function () { return handleActionTypeChange(ACTIONS.deposit, "v2"); } }, { children: _jsx(FormTabTitle, __assign({ active: vaultActionForm.actionType === ACTIONS.deposit }, { children: t("shared:VaultV2DepositWithdrawForm:deposit") }), void 0) }), void 0), _jsx(FormTab, __assign({ active: vaultActionForm.actionType === ACTIONS.withdraw, onClick: function () { return handleActionTypeChange(ACTIONS.withdraw, "v2"); } }, { children: _jsx(FormTabTitle, __assign({ active: vaultActionForm.actionType === ACTIONS.withdraw }, { children: t("shared:VaultV2DepositWithdrawForm:withdraw") }), void 0) }), void 0)] }, void 0), _jsxs("div", __assign({ className: "d-flex flex-column p-4 w-100" }, { children: [formContent, bridgeAvaxCTA, formInfoText, swapContainerTrigger] }), void 0), swapContainer] }, void 0));
};
export default VaultV2DepositWithdrawForm;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=VaultV2DepositWithdrawForm.js.map